// @ts-nocheck

// components
import React, { useEffect, useRef } from 'react';

// antd
import { Modal, Form, Input, Checkbox, ConfigProvider } from 'antd';

// hooks
import useSelection from './SelectionHooks';

// style
import './style.scss';
import classNames from 'classnames';

const { TextArea } = Input;

interface IProps {
    selectedText: string;
    docLang?: string;
    docVersion?: string;
    nullText?: boolean;
    isShow?: boolean;
    setIsShow?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Selection: React.FC<IProps> = props => {
    const {
        selectedText,
        docLang = 'zh',
        docVersion = '',
        nullText = false,
        isShow = false,
        setIsShow = () => {}
    } = props;

    const {
        isModalOpen,
        initialValues,
        options,
        form,

        showModal,
        handleOk,
        handleCancel,
        onFinish,
        onValuesChange
    } = useSelection(docLang, docVersion);

    const selectionRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        form.setFieldsValue({ text: selectedText });
        if (isShow) {
            showModal();
        }
    }, [selectedText, form, isShow, showModal]);

    return (
        <>
            {nullText ? (
                <span ref={selectionRef} onClick={() => selectedText && showModal()}></span>
            ) : (
                <div className="feed-back-selection" ref={selectionRef} onClick={() => selectedText && showModal()}>
                    <>
                        <span className="feed-back-selection-icon" />
                        文档反馈
                    </>
                </div>
            )}
            <ConfigProvider>
                <Modal
                    title={<div style={{ textAlign: 'center' }}>文档问题反馈</div>}
                    centered
                    visible={isModalOpen}
                    onOk={handleOk}
                    okText="提交"
                    cancelText="取消"
                    wrapClassName="feed-back-selection-modal"
                    onCancel={() => {
                        if (isShow) {
                            setIsShow(false);
                        }
                        if (selectionRef.current) {
                            selectionRef.current.style.display = 'none';
                        }
                        handleCancel();
                    }}
                    width={600}
                    getContainer={document.body}
                >
                    <Form
                        layout="horizontal"
                        onFinish={onFinish}
                        form={form}
                        initialValues={initialValues}
                        onValuesChange={onValuesChange}
                    >
                        <Form.Item
                            label="标记内容"
                            name="text"
                            className={classNames({
                                'feed-back-selection-modal-text': nullText
                            })}
                        >
                            <TextArea
                                className="feed-back-selection-textarea"
                                autoSize={nullText ? { minRows: 1, maxRows: 1 } : { minRows: 1, maxRows: 4 }}
                                disabled
                            />
                        </Form.Item>

                        <Form.Item label="问题类型" name="type" rules={[{ required: true }]}>
                            <Checkbox.Group options={options} />
                        </Form.Item>
                        <Form.Item label="反馈建议" name="desc">
                            <TextArea
                                placeholder="建议你输入反馈意见，帮助我们精准定位及解决你的问题"
                                autoSize={{ minRows: 4, maxRows: 4 }}
                            />
                        </Form.Item>
                        <Form.Item label="你的邮箱" name="email">
                            <Input placeholder="建议你留下邮箱地址，便于同步优化进展" />
                        </Form.Item>
                    </Form>
                    <div style={{color: '#999', fontSize: '12px', padding: '0 10px'}}>
                        若对 Paddle 框架的使用存在疑问，或者发现 Bug，又或者有新功能的建议，请前往 GitHub 仓库的 issue 区提出：
                        <a href='https://github.com/PaddlePaddle/Paddle/issues' rel="noreferrer" target='_blank'>https://github.com/PaddlePaddle/Paddle/issues</a>
                    </div>
                </Modal>
            </ConfigProvider>
        </>
    );
};

const getSelection = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const getSelectTxt = () => document.getSelection()?.toString();

    e = e || window.event;
    let sh = document.documentElement.scrollTop || document.body.scrollTop || 0;
    let left = e.clientX - 40 < 0 ? e.clientX + 20 : e.clientX - 40;
    let top = e.clientY - 40 < 0 ? e.clientY + sh + 20 : e.clientY + sh + 12;
    const feedDom = document.querySelector('.feed-back-selection') as HTMLDivElement;

    if (feedDom) {
        const txt = getSelectTxt();
        if (txt !== null && txt?.trim() !== '') {
            feedDom.style.display = 'inline-block';
            feedDom.style.left = left + 'px';
            feedDom.style.top = top + 'px';
            return txt?.trim() ?? '';
        } else {
            feedDom.style.display = 'none';
        }
    }

    return '';
};

export { getSelection };
export default Selection;
